module.exports = __webpack_public_path__ + "static/media/cinema-background.a0b12c8d.jpg";